module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"cancel":"Cancelar","ok":"Aceptar"},"en":{"cancel":"Cancel","ok":"OK"}}')
  delete Component.options._Ctor
}
